<template>
  <div class="comp-container">
    <div class="showbox">
      <div id="showboxImage"></div>
      <div class="title">
        <Navbar/>
        <h1>
          How is the weather?
          <span>Compare weather charts of several cities</span>
        </h1>
        <div v-if="unsplashUsernameURL" class="credit">
          <a :href="unsplashUsernameURL" target="_blank">Photo by {{unsplashUsernameName}}</a> on
          <a :href="unsplashURL" target="_blank">Unsplash</a> 
        </div>
      </div>
    </div>

    <Scrollitelling/>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/NavBar";
import Footer from "@/components/Footer";
import Scrollitelling from "@/components/Scrollitelling";
import firebase from "firebase/app";
import "firebase/functions";

export default {
  name: "Scroll",
  components: {
    Navbar,
    Scrollitelling,
    Footer
  },
  data() {
    return {
      showboxImageURL: null,
      unsplashUsernameURL: null,
      unsplashUsernameName: null
    };
  },
  created() {
    this.displayRandomPhoto();
  },
  methods: {
    loadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener("load", () => resolve(img));
        img.addEventListener("error", err => reject(err));
        img.src = src;
      });
    },
    displayRandomPhoto() {
      let randomPhotoData = firebase
        .functions()
        .httpsCallable("getRandomPhoto");
      randomPhotoData({ featured: "true", width: 2400, query: "weather" })
        .then(result => {
          console.log(result.data.user);
          this.unsplashUsernameName = result.data.user.name;
          let utmStr = "?utm_source=spdl_random&utm_medium=referral"
          this.unsplashUsernameURL =result.data.user.links.html + utmStr;
          this.unsplashURL =
            "https://unsplash.com/" + utmStr;
          
          let photoURL = result.data.urls.custom;
          this.getShowboxImage(photoURL);
        })
        .catch(err => {
          console.log("Something busted with Unsplash: " + err);
          this.getShowboxImage(
            "https://source.unsplash.com/featured/1600x900/?weather}"
          );
        });
    },
    getShowboxImage(photoURL) {
      // console.log(photoURL);

      this.loadImage(photoURL).then(img => {
        // console.log("Photo loaded and ready for use");
        let photoURL = img.src;
        let imgEl = document.getElementById("showboxImage");
        imgEl.style.backgroundImage = "url(" + photoURL + ")";
        imgEl.setAttribute("class", "fade");
      });
    }
  }
};
</script>

<style  scoped lang="stylus">
.home {
  height: 500px;
  display: block;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  20% {
    opacity: 0;
  }

  60% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

.showbox {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 400px;
  overflow: hidden;
  background-color: #e6ecef;
  margin-bottom: 50px;

  & h1 {
    margin-top: 80px;
  }

  & .fade {
    width: 100%;
    height: 100%;
    animation-name: fadeIn;
    animation-duration: 5s;
    animation-timing-function: linear;
    position: absolute;
    background-position: center;
    background-size: cover;
  }

  & .title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      rgba(245, 245, 245, 0.9),
      rgba(245, 255, 250, 0.6)
    );
  }

  & .credit {
    font-size: 10px;
    position: absolute;
    left: 10px;
    bottom: 5px;

    a {
      color: #666;
      text-decoration: none;
    }
  }
}

h1 {
  & span {
    font-size: 14px;
    display: block;
    line-height: 36px;
    padding-top: 20px;
    font-weight: normal;
  }
}

.intro {
  margin: 60px auto 30px;
  padding: 10px 20px 10px 40px;
  max-width: 700px;
  background-color: rgba(255, 255, 255, 0.75);
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;

  & .p {
    margin: 10px 0;
  }
}
</style>
